module.exports = __webpack_public_path__ + "c92914f714bdf9e9b02713c6e9fba75c.ttf";